import { Paper, Stack, styled } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { WHITE } from "../../colors";
import ChatLeft from "./ChatLeft";
import ChatRight from "./ChatRight";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  padding: 10,
  overflowY: "scroll",
  height: "98%",
  boxShadow: "none",
}));
const user = JSON.parse(localStorage.getItem("user"))?.data;

const ChatList = ({ limit, feedList, loadMore }) => {
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [feedList]);
  return (
    <Container>
      {limit % 50 > 0 && (
        <span
          style={{
            margin: "10px 0 20px 0",
            display: "inline-block",
            cursor: "pointer",
          }}
          onClick={() => loadMore()}
        >
          Load more ...{" "}
        </span>
      )}
      <Stack>
        {feedList?.map((f) =>
          f?.employee !== user?.id ? (
            <ChatLeft key={f.id} feed={f} user={user} />
          ) : (
            <ChatRight feed={f} key={f.id} user={user} />
          )
        )}
        <div ref={messagesEndRef} />
      </Stack>
    </Container>
  );
};

export default ChatList;
